import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Container,
  Divider,
  Flex,
  Heading,
  HStack,
  SkeletonText,
  Stack,
  Table,
  Tag,
  Tbody,
  Td,
  Text,
  Tr,
} from "@chakra-ui/react";
import ButtonEmailPreview from "components/ButtonEmailPreview";
import CompanyHeader from "components/ui/CompanyHeader";
import DateTime from "components/ui/DateTime";
import HeaderBarInternal from "components/ui/HeaderBarInternal";
import InfoList from "components/ui/InfoList";
import TagEmailStatus from "components/ui/TagEmailStatus";
import { LinkNewsletterPreview } from "features/emails/config";
import EmailSentStats from "features/reports/components/EmailSentStats";
import { useResource } from "hooks/useResource";
import { useLocation, useParams } from "react-router-dom";

export default function PageNewsletterDetail() {
  const { id } = useParams();
  const location = useLocation();
  const { data: report, isLoading } = useResource({
    id: id as string,
    resourceName: "newsletter",
    path: "newsletters/send-report",
  });

  return (
    <>
      <HeaderBarInternal
        title="Visualizar Disparo de Newsletter"
        backTo={`/disparos-de-newsletter${location.search}`}
      ></HeaderBarInternal>

      <Divider />

      <Container variant="internal" flexDirection="column" mb="80px">
        <SkeletonText isLoaded={!isLoading}>
          {report && (
            <>
              <Card>
                <CardHeader>
                  <Flex alignItems="center">
                    <Stack spacing="5px" alignItems="flex-start" mr="25px">
                      <Heading as="h3" size="h3">
                        {report.subject}
                      </Heading>
                      <HStack spacing="8px">
                        <TagEmailStatus record={report} />
                        {report.reviewedByUserId && (
                          <Tag size="sm" colorScheme="gray">
                            Revisado
                          </Tag>
                        )}
                      </HStack>
                    </Stack>
                    <ButtonEmailPreview url={LinkNewsletterPreview(report)} />
                  </Flex>
                </CardHeader>
                <CardBody>
                  <InfoList
                    mt="10px"
                    ml={0}
                    justifyContent="flex-start"
                    spacing="35px"
                  >
                    <Box>
                      <Text as="span">
                        <small>Assunto do e-mail</small>
                        {report.subject}
                      </Text>
                    </Box>
                    <Box>
                      <Text as="span">
                        <small>Criado em</small>
                        <DateTime date={report.createdAt} noBreak />
                      </Text>
                    </Box>
                    {report.reviewedAt && (
                      <Box>
                        <Text as="span">
                          <small>Revisado em</small>
                          <DateTime date={report.reviewedAt} noBreak />
                        </Text>
                      </Box>
                    )}
                    {report.reviewedBy && (
                      <Box>
                        <Text as="span">
                          <small>Revisado por</small>
                          {report.reviewedBy.name}
                        </Text>
                      </Box>
                    )}
                    <Box>
                      <Text as="span">
                        <small>Enviado em</small>
                        <DateTime date={report.email.createdAt} noBreak />
                      </Text>
                    </Box>
                  </InfoList>

                  <InfoList
                    mt="25px"
                    ml={0}
                    justifyContent="flex-start"
                    spacing="35px"
                  >
                    <Box>
                      <Text as="span">
                        <small>Destinatários</small>
                        {report.email.countRecipients}
                      </Text>
                    </Box>
                    <Box>
                      <Text as="span">
                        <small>Enviados</small>
                        {report.email.countSent}
                      </Text>
                    </Box>
                    <Box>
                      <Text as="span">
                        <small>Bounce</small>
                        {report.email.countBounce}
                      </Text>
                    </Box>
                  </InfoList>
                </CardBody>
              </Card>

              <Card mt="30px">
                <CardHeader>
                  <Heading as="h3" size="h3">
                    Lista
                    <Text as="span"></Text>
                  </Heading>
                </CardHeader>
                <CardBody>
                  <Stack spacing="50px">
                    <Box>
                      <CompanyHeader
                        company={report.list.company}
                        description=""
                      />
                      <Table mt="23px">
                        <Tbody>
                          <Tr key={report.list.id}>
                            <Td>{report.list.name}</Td>
                            <Td>
                              {report.list.isNewsletter && (
                                <Tag colorScheme="green">Newsletter</Tag>
                              )}
                            </Td>
                            <Td w="600px">
                              <HStack spacing="8px" flexWrap="wrap">
                                {report.list.tags.map((tag) => (
                                  <Tag
                                    key={`tag-${tag.id}`}
                                    colorScheme={tag.colorScheme}
                                  >
                                    {tag.name}
                                  </Tag>
                                ))}
                              </HStack>
                            </Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </Box>
                  </Stack>
                </CardBody>
              </Card>

              <Card mt="30px">
                <CardHeader>
                  <Heading as="h3" size="h3">
                    Estatísticas de envio
                  </Heading>
                </CardHeader>

                <CardBody>
                  <EmailSentStats email={report.email} />
                </CardBody>
              </Card>
            </>
          )}
        </SkeletonText>
      </Container>
    </>
  );
}
